import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AuthenticationModalWrapper from 'app/pages/App/components/AuthenticationModalWrapper';
import { OTPInput } from 'app/pages/App/components/OTPRegister';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import OtpInput from 'react-otp-input';
import { GradientBtn } from 'app/pages/App/components/DialogRegister';
import styled from 'styled-components';

interface OTPVerificationProps {
  loading?: boolean;
  onVerifyOtp: (otp: string) => void;
}

const OTPVerification = (props: OTPVerificationProps) => {
  const { loading, onVerifyOtp } = props;
  const translations = useSelector(selectTranslations);
  const [otp, setOtp] = useState('');

  return (
    <AuthenticationModalWrapper
      isShow={true}
      title={
        translations
          ? translations['b2c.txt.enterOtpSentInTheEmail']
          : 'Vui lòng nhập OTP 6 số gửi kèm trong email'
      }
      onCloseDialog={() => {}}
      closable={false}
    >
      <OTPContainer>
        <OtpInput
          inputType="number"
          value={otp}
          numInputs={6}
          renderInput={props => <OTPInput {...props} />}
          onChange={otp => {
            setOtp(otp);
          }}
        />
        <GradientBtn
          style={{ fontWeight: 600 }}
          onClick={() => {
            onVerifyOtp(otp);
          }}
        >
          {loading ? 'Loading...' : translations?.['b2c.txt.confirm'] ?? ''}
        </GradientBtn>
      </OTPContainer>
    </AuthenticationModalWrapper>
  );
};

export default OTPVerification;

const OTPContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 24px;
`;
